import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
// @mui
import { Typography } from '@mui/material';
// assets
import { SeverErrorIllustration } from '../assets';
import { useLocation, useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(10, 0),
  textAlign: 'center',
  alignItems: 'center',
  '& .illustration': {
    height: 260,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(10),
    },
    '& .primary-main': {
      fill: '#2AA43C',
      stopColor: '#2AA43C',
    },
    '& .primary-dark': {
      fill: '#207B2D',
    },
    '& .primary-darker': {
      fill: '#15531E',
    },
    '& .primary-light': {
      fill: '#B9EDC1',
    },
    '& .primary-lighter': {
      fill: '#E9F7EA',
    },
    '& .GGG-GGG-GGG': {
      border: '3px solid red',
    },
  },
}));

// ----------------------------------------------------------------------

const NoInternetConnection = (props: any) => {
  const [isOnline, setOnline] = useState(true);
  const location = useLocation();
  const navigate = useNavigate()
  useEffect(() => {
    setOnline(navigator.onLine);
  },[location]);

  window.addEventListener('online', () => {
    if(!isOnline){
      setOnline(true);
      navigate(0)
    }
  });

  // if user is online, return the child component else return a custom component
  if (isOnline) {
    return props.children;
  } else {
    return (
      <ContentStyle>
        <Typography variant="h4" paragraph>
          Connection Lost
        </Typography>

        <Typography sx={{ color: 'text.secondary' }}>
          Please check your network connection and try again
        </Typography>

        <SeverErrorIllustration className="illustration" />
      </ContentStyle>
    );
  }
};

export default NoInternetConnection;
